<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<div class="form-box" v-if="form">
            <el-table :data="form" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column prop="country" label="国家地区" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="place" label="省/市/区" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column prop="address" label="详细地址" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column prop="yzCode" label="邮政编码" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"> </el-table-column>
			</el-table>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	export default {
		name: "ShowAddress",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
			};
		},
		mounted() {
		},
		methods: {
		}
	};
</script>
<style scoped="scoped">
</style>